// Local imports
import classes from "./style.module.css";
import languageConfig from "@/export/config";
import Item from "./Item";

// Component props for List
interface Props {
  text: string;
}

export default function List({ text }: Props) {
  return (
    <div className={`${classes.list}`}>
      {languageConfig?.routes.fonts?.fonts.map((font) => (
        <Item
          key={font.name}
          url={font.name}
          downloadPath={font.downloadPath}
          titleEn={font.titleEn}
          titleMl={font.titleMl}
          text={text}
          cssName={font.cssName}
        />
      ))}
    </div>
  );
}
